import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_STARTER_DASHBOARD_SIGNATURE_SOURCES = createFcmDetails(
	'starfish_starter_dashboard_signature_sources',
	{
		owner: 'Starfish',
		context: 'Starter Dashboard page',
		import: false,
		description: `Feature release flag that enables the starter Top Signature Sources UI on the starter dashboard.
			Top Signature Sources is part of Petition Insights.`,
		template: {
			enabled: false,
			earliest_petition_published_at: '2024-03-01', // 'yyyy-mm-dd'
			minimum_signature_count: 5,
		},
	},
);
